export enum PatientTableColumnTitle {
  FirstName = "Ime",
  LastName = "Prezime",
  Birthday = "Godina rođenja",
  ProgramName = "Program",
  GDPR = "GDPR privola",
  Action = "akcija",
}
